import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=054df2ed&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=js"
export * from "./UserDetails.vue?vue&type=script&lang=js"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=054df2ed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054df2ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054df2ed')) {
      api.createRecord('054df2ed', component.options)
    } else {
      api.reload('054df2ed', component.options)
    }
    module.hot.accept("./UserDetails.vue?vue&type=template&id=054df2ed&scoped=true", function () {
      api.rerender('054df2ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/UserDetails.vue"
export default component.exports